import { isSessionStorageAvailable } from '@/utils/session-storage';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const useCheckSessionStorage = () => {
  const router = useRouter();

  useEffect(() => {
    const isAvailable = isSessionStorageAvailable();

    if (!isAvailable && !router.pathname.includes('blocked-cookies'))
      void router.push('/blocked-cookies');
  }, [router.pathname]);
};

export { useCheckSessionStorage };
